<template>
  <div>
    <div class="menus_sidebar">
      <div class="menus-head">
        <i class="icon-menus"></i>
        <h1>MENUS</h1>
        <router-link to="/platoform" class="btn btn-fill btn-sm">NUEVO PLATO</router-link>
      </div>
      <div class="menus-filter smart-form">
        <div class="form-group">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Búsqueda rápida" v-model="platoSearch">
            <span class="input-group-btn">
            <button class="btn btn-default js-buscar" type="button"><i class="fa fa-search"></i></button>
            </span>
          </div>
        </div>
        <div class="form-group">
          <label>CATEGORÍA</label>
          <div class="select">
            <select class="form-control" v-model="categoriaSeleccionada">
              <option value="-1">Todas</option>
              <option v-for="categoria in categorias" :value="categoria._id" :key="categoria._id">{{categoria.nombre}}</option>
            </select>
            <i></i>
          </div>
        </div>
      </div>
      <div class="smart-form" v-if="paginador.totalItems > 0">
        <div class="text-center center-block">
          <nav aria-label="Page navigation">
            <ul class="pagination pagination-sm">
            <li>
              <a @click="goToPrevPage()"  aria-label="Anterior">
              <span aria-hidden="true">«</span>
              </a>
            </li>
            <li><span>Página {{paginador.currentPage}} de {{totalPages}}</span></li>
            <li>
              <a @click="goToNextPage()" aria-label="Siguiente">
              <span aria-hidden="true">»</span>
              </a>
            </li>
            </ul>
          </nav>
        </div>
      </div>
      <lista-platos :platos="platosPaginados"></lista-platos>
    </div>
    
    <div class="push_sidebar widget-name">
      <!--  Contenedor gestor de menus-->
      <section class="section menus-manager">
        <div class="container">
          <h1 class="admin-page">Gestión de menús</h1>
          <div class="pull-right">
            <button class="btn btn-fill" @click="clickGuardar()">Guardar Menu</button>
          </div>
          <div ref="calendario" id="calendario"></div>     
        </div>
      </section><!-- Fin contenedor gestor de menus-->
    </div>
      <div class="modal fade detalle-menu" id="detalle-menu" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document" v-if="selectedMenu">
      <div class="modal-content" v-if="selectedMenu.plato">
        <div class="modal-body" >
        <button type="button" class="close" @click="cancelarEditarStock()"><span aria-hidden="true">&times;</span></button>
        <h2>{{selectedMenu.plato.nombre}}</h2>
        <br/>
        <div class="row">
          <div class="col-sm-3">
            <b>Tiene stock : {{selectedMenu.outOfStock}} </b>
          </div>
          <div class="col-sm-2">
            <button @click="toggleOutOfStock(false)" class="btn btn-sm" :class="{'btn-fill': !selectedMenu.outOfStock, 'btn-outline-grey-green': selectedMenu.outOfStock}">Con Stock</button>
          </div>
          <div class="col-sm-2">
            <button @click="toggleOutOfStock(true)" class="btn btn-sm" :class="{'btn-fill': selectedMenu.outOfStock, 'btn-outline-grey-green': !selectedMenu.outOfStock}">Sin Stock</button>
          </div>
          <div class="col-sm-2" v-if="!selectedMenu.outOfStock">
            <button @click="toggleLimited(false)" class="btn btn-sm" :class="{'btn-fill': !selectedMenu.limited, 'btn-outline-grey-green': selectedMenu.limited}">Ilimitado</button>
          </div>
          <div class="col-sm-2" v-if="!selectedMenu.outOfStock">
            <button class="btn btn-sm" @click="toggleLimited(true)" :class="{'btn-fill': selectedMenu.limited, 'btn-outline-grey-green': !selectedMenu.limited}">Limitado</button>
          </div>
        </div>
        <br/>
        <div class="row" v-if="!selectedMenu.outOfStock && selectedMenu.limited">
          <div class="col-sm-3">
            <b>Stock : </b>
          </div>
          <div class="col-sm-2">
            <input type="number" :value="selectedMenu.stock" v-model="selectedMenu.stock" ref="stock" class="form-control">
          </div>
        </div>            
        </div>
        <br/>
        <div class="row">
          <div class="col-sm-12 col-md-12 text-center">
            <button type="button" class="btn btn-fill btn-sm" @click="guardarSelectedMenu()">GUARDAR</button>
          </div>
        </div>
        <br/>        
      </div>
      </div>
    </div><!-- Fin modal comanda-->
  </div>
</template>
<script>
  import $ from 'jquery'
  import moment from 'moment'
  import '../../assets/js/jquery-ui.min.js'
  import '../../assets/css/admin.css'
  import '../../assets/css/fullcalendar.css'
  import 'fullcalendar'
  import 'fullcalendar/dist/locale/es'
  import ListaPlatos from './ListaPlatos'
  import _ from 'lodash'
  import async from 'async'
  import 'sweetalert2/dist/sweetalert2.css'
  import swal from 'sweetalert2'
  moment.locale('es')

  // const fechaHoy = new Date()
  export default {
    computed: {
      platosLista () {
        const me = this
        let platos = me.platos
        me.paginador.currentPage = 1
        if (me.categoriaSeleccionada !== '-1') {
          platos = platos.filter((plato) => {
            return plato.categoria._id === me.categoriaSeleccionada
          })
        }
        platos = platos.filter((plato) => {
          return plato.nombre.trim().toLowerCase().includes(me.platoSearch.trim().toLowerCase())
        })
        return platos
      },
      platosPaginados () {
        const me = this
        let desde = (me.paginador.currentPage - 1) * me.paginador.pageSize
        let hasta = me.paginador.currentPage * me.paginador.pageSize
        let filtrados = me.platosLista.filter((plato, idx) => {
          return idx >= desde && idx < hasta
        })
        return filtrados
      },
      totalItems () {
        return this.platosLista.length
      },
      totalPages () {
        return Math.ceil(this.totalItems / this.paginador.pageSize)
      }
    },
    components: {
      'lista-platos': ListaPlatos
    },
    data () {
      return {
        selectedMenu: {},
        originalSelectedMenu: {},
        cache: {},
        calendario: undefined,
        categorias: [],
        categoriasObligatorias: [],
        categoriaSeleccionada: '-1',
        coloresCategorias: ['#B3FF99', '#FFE1B2', '#9AC4F8', '#FFD4CA', '#F3D9B1'],
        maxDate: moment().add(30, 'days'),
        minDate: moment().add(-1, 'days').startOf('day').toDate(),
        paginador: {
          pageSize: 4,
          currentPage: 1,
          totalItems: 0,
          totalPages: 0
        },
        stock: {},
        platos: [],
        platosAgregadosUsuarios: [],
        platosMenu: [],
        platosServidor: [],
        platoSearch: '',
        puedeSalir: true,
        sucursalesAsociadas: [],
        timeZone: 'America/Argentina/Cordoba'
      }
    },
    mounted () {
      $('body').addClass('admin show_sidebar')
      const me = this

      me.$http.get('/api/restaurante/initmenu').then(({body}) => {
        console.log(body)
        me.platos = body[0]
        me.categorias = body[1]
        me.paginador.totalItems = me.platos.length
        me.paginador.totalPages = Math.ceil(me.paginador.totalItems / me.paginador.pageSize)
        me.sucursalesAsociadas = body[2]
        let categorias = []
        me.sucursalesAsociadas.forEach((sucursal) => {
          if (sucursal.subsidio) {
            sucursal.subsidio.comboAsignado.reglas.forEach((regla) => {
              categorias.push(regla.categoria)
            })
          }
        })
        me.categoriasObligatorias = [...new Set(categorias)]
      }, (err) => {
        console.log(err)
      }).then(() => {
        me.calendario = $(me.$refs.calendario).fullCalendar({
          header: {
            left: 'prev,next today',
            center: 'title'
            // right: 'reload'
          },
          disableDragging: true,
          editable: false,
          weekends: true,
          defaultView: 'basicWeek',
          hiddenDays: [0],
          eventlimit: true,
          droppable: true, // this allows things to be dropped onto the calendar
          timezone: me.timeZone,
          dayRender: (date, cell) => {
            if (date > me.maxDate || date < me.minDate) {
              cell.css('backgroundColor', '#F2DEDE')
              return
            }
            // let fechaFormateada = date.utc().format('YYYY-DD-MM')
            // let estaCompleto = me.estaCompletoDia(fechaFormateada)
            // let $calendario = $(me.$refs.calendario)
            // let $cabecera = $calendario.find('thead.fc-head th').eq(cell.index())
            // // $cabecera.html($cabecera.text() + '<i class="fa fa-user"></i>')
            // if (estaCompleto) {
            //   console.log($cabecera.text())
            // } else {
            //   $cabecera.css({'background-color': 'rgba(242, 222, 222, .5)'})
            // }
            // $('thead.fc-head tr th').eq(cell.index()).text()
          },
          drop () {
            // is the "remove after drop" checkbox checked?
            if ($('#drop-remove').is(':checked')) {
              // if so, remove the element from the "Draggable Events" list
              $(this).remove()
            }
          },
          eventOrder: 'order',
          /*
          customButtons: {
            reload: {
              text: 'Reload',
              click () {
                console.log('amorfo')
              }
            }
          },
          */
          eventClick (event, jsEvent, view) {
            jsEvent.preventDefault()
            const $elemento = $(jsEvent.target)
            const esEditarStock = $elemento.hasClass('edit-stock')
            if (esEditarStock) {
              let day = event.start.format('YYYY-MM-DD')
              let stock = me.stock[day + '_' + event.idPlato]
              if (!stock) {
                stock = {outOfStock: false, limited: false, stock: 0}
                me.stock[day + '_' + event.idPlato] = stock
              }
              event.limited = stock.limited
              event.stock = stock.stock
              event.outOfStock = stock.outOfStock
              me.originalSelectedMenu = _.cloneDeep(event)
              me.selectedMenu = event
              $('#detalle-menu').modal()
            }
            const esBorrar = $elemento.hasClass('js-delete-event')
            if (esBorrar) {
              let ids = [event._id]
              me.calendario.fullCalendar('removeEvents', ids)
              me.puedeSalir = false
              let existePlatoEnMenu = me.platosMenu.findIndex((platoMenu) => {
                return platoMenu.fechaFormateada === event.start.format('YYYY-MM-DD') && event.plato._id === platoMenu.plato._id
              })
              if (existePlatoEnMenu > -1) {
                me.platosMenu.splice(existePlatoEnMenu, 1)
              }
            }
          },
          eventReceive (event) {
            const fechaFormateada = event.start.format('YYYY-MM-DD')
            if (event.start < me.minDate || event.start > me.maxDate) {
              me.$emit('mostrar-notificacion', 'No se pueden agregar platos en ese fecha', 'error')
              me.calendario.fullCalendar('removeEvents', event._id)
              return false
            }

            let existePlato = me.platosMenu.find((plato) => {
              return plato.fechaFormateada === fechaFormateada && plato.plato._id === event.plato._id
            })
            if (existePlato) {
              me.$emit('mostrar-notificacion', 'El plato ya existe para ese día', 'error')
              me.calendario.fullCalendar('removeEvents', event._id)
              return false
            }
            let evento = {
              plato: event.plato,
              fecha: event.start,
              limited: false,
              stock: 0,
              outOfStock: false,
              fechaFormateada: fechaFormateada
            }
            me.platosMenu.push(evento)
            me.puedeSalir = false
            // me.platosAgregadosUsuarios.push(evento)
          },
          eventRender (event, element) {
            let html = `<small  style="margin-top: 1em; color: #FFF; 
              background-color: #555; margin: .3em; padding-left: 0.3em; padding-right: 0.3em;" class="pull-right">
                ${event.plato.categoria.nombre}
              </small>`
            element.append(html)
            if (event.start.toDate() > me.minDate) {
              let day = event.start.format('YYYY-MM-DD')
              let stock = me.stock[day + '_' + event.idPlato]
              if (!stock) {
                stock = {limited: false, stock: 0, outOfStock: false}
                me.stock[day + '_' + event.idPlato] = stock
              }
              if (stock.limited) {
                html = `<small  style="cursor:pointer; margin-top: 1em; color: #FFF; 
                  background-color: #555; margin: .3em; padding-left: 0.3em; padding-right: 0.3em;" class="edit-stock pull-left">
                    Stock : ${stock.stock}
                </small>`
              } else {
                html = `<small style="cursor:pointer; margin-top: 1em; color: #FFF; 
                  background-color: #555; margin: .3em; padding-left: 0.3em; padding-right: 0.3em;" class="edit-stock pull-left">
                    Stock : Ilimitado
                </small>`
              }
              element.append(html)
            }
            let idxCategoria = me.categorias.findIndex((categoria) => {
              return categoria._id === event.plato.categoria._id
            })
            if (event.start.toDate() > me.minDate) {
              element.prepend('<a class="btn btn-info btn-xs pull-right js-delete-event"><i class="fa fa-remove js-delete-event"></i></a>')
            }
            element.css({
              'background-color': me.coloresCategorias[idxCategoria]
            })
          },
          events (start, end, timeZone, callback) {
            let datos = {
              fechaInicio: start.toDate(),
              fechaFin: end.toDate()
            }
            let eventosCalendario = []
            let rangoFechas = +datos.fechaInicio + '-' + +datos.fechaFin
            if (me.cache[rangoFechas]) {
              eventosCalendario = me.calendario.fullCalendar('clientEvents')
              let platosLocales = me.platosMenu.filter((plato) => {
                let estaEnCalendario = eventosCalendario.find((evento) => {
                  return evento.start.format('YYYY-MM-DD') === plato.fechaFormateada && plato.plato._id === evento.plato._id
                })
                return plato.fecha >= datos.fechaInicio && plato.fecha <= datos.fechaFin && !estaEnCalendario
              })
              let eventos = me.platosMenuAEventos(platosLocales)
              return callback(eventos)
            }
            async.waterfall([
              (done) => {
                me.$emit('activar-modal')
                me.$http.post('/api/restaurante/menu', datos).then(({body}) => {
                  me.cache[rangoFechas] = body.menus
                  me.stock = {}
                  let menuComoEventos = []
                  body.stock.forEach((stock) => {
                    me.stock[stock.fechaFormateada + '_' + stock.plato] = stock
                  })
                  body.menus.forEach((itemMenu) => {
                    itemMenu.platos.forEach((plato) => {
                      return menuComoEventos.push({
                        plato: plato,
                        fecha: new Date(itemMenu.fecha),
                        fechaFormateada: moment(new Date(itemMenu.fecha)).utc().format('YYYY-MM-DD')
                      })
                    })
                  })
                  done(null, menuComoEventos)
                }, (err) => {
                  done(err)
                })
              },
              (eventosServidor, done) => {
                eventosCalendario = me.calendario.fullCalendar('clientEvents')
                // console.log('eventosCalendario', eventosCalendario)
                eventosServidor.forEach((eventoServidor) => {
                  let existeEnMenu = eventosCalendario.find((evento) => {
                    return evento.start.format('YYYY-MM-DD') === eventoServidor.fechaFormateada && evento.plato._id === eventoServidor.plato._id
                  })
                  if (!existeEnMenu) {
                    me.platosMenu.push(eventoServidor)
                  }
                })
                let platosFiltradosFecha = me.platosMenu.filter((plato) => {
                  let estaEnCalendario = eventosCalendario.find((evento) => {
                    console.log(evento)
                    return evento.start.format('YYYY-MM-DD') === plato.fechaFormateada && evento.plato._id === plato.idPlato
                  })
                  return plato.fecha >= datos.fechaInicio && plato.fecha <= datos.fechaFin && !estaEnCalendario
                })
                let platosLocalesComoEventos = me.platosMenuAEventos(platosFiltradosFecha)
                done(null, platosLocalesComoEventos)
              //   let platosServidor = []
              //   eventosServidor.forEach((menuDia) => {
              //     menuDia.platos.forEach((plato) => {
              //       let platoEnDia = me.platosMenu.find((platoMenu) => {
              //         return platoMenu.plato._id === plato._id && moment(new Date(menuDia.fecha)).utc().format('YYYY-MM-DD') === platoMenu.fechaFormateada
              //       })
              //       if (!platoEnDia) {
              //         let platoInsertar = {
              //           plato: plato,
              //           fecha: new Date(menuDia.fecha),
              //           fechaFormateada: moment(new Date(menuDia.fecha)).utc().format('YYYY-MM-DD')
              //         }
              //         me.platosMenu.push(platoInsertar)
              //       }
              //       platosServidor.push({
              //         fecha: moment(new Date(menuDia.fecha)).utc().toDate(),
              //         fechaFormateada: moment(new Date(menuDia.fecha)).utc().format('YYYY-MM-DD'),
              //         plato: plato
              //       })
              //     })
              //   })
              //   let platosLocalesComoEventos = platosServidor.map((plato) => {
              //     return {
                    // title: plato.plato.nombre,
                    // order: plato.plato.categoria.nombre.toUpperCase() + ' ' + plato.plato.nombre,
                    // idPlato: plato.plato._id,
                    // plato: plato.plato,
                    // start: moment(plato.fecha).utc(),
                    // fechaFormateada: plato.fechaFormateada,
                    // allDay: true
              //     }
              //   })
              //   done(null, platosLocalesComoEventos)
              }], (err, platosLocalesComoEventos) => {
              me.$emit('cerrar-modal')
              if (err) {
                return console.log(err)
              }
              callback(platosLocalesComoEventos)
            })
          }
        })
      })
    },
    methods: {
      cancelarEditarStock () {
        const me = this
        me.selectedMenu = _.cloneDeep(me.originalSelectedMenu)
        me.calendario.fullCalendar('updateEvent', me.selectedMenu)
        $('#detalle-menu').modal('toggle')
      },
      guardarSelectedMenu () {
        const me = this
        console.log(me.selectedMenu)
        let day = me.selectedMenu._start.format('YYYY-MM-DD')
        me.stock[day + '_' + me.selectedMenu.idPlato] = {limited: me.selectedMenu.limited, outOfStock: me.selectedMenu.outOfStock}
        if (me.stock[day + '_' + me.selectedMenu.idPlato].limited) {
          me.stock[day + '_' + me.selectedMenu.idPlato].stock = me.selectedMenu.stock
        }
        me.calendario.fullCalendar('updateEvent', me.selectedMenu)
        $('#detalle-menu').modal('toggle')
      },
      toggleOutOfStock (outOfStock) {
        const me = this
        if (outOfStock) {
          me.selectedMenu.outOfStock = true
          me.selectedMenu.limited = true
          me.selectedMenu.stock = 0
        } else {
          me.selectedMenu.outOfStock = false
          me.selectedMenu.limited = false
        }
        this.$forceUpdate()
        return true
      },
      toggleLimited (limited) {
        const me = this
        if (limited) {
          me.selectedMenu.limited = true
          me.selectedMenu.stock = 1
        } else {
          me.selectedMenu.limited = false
          me.selectedMenu.stock = 0
        }
        this.$forceUpdate()
        return true
      },
      clickGuardar () {
        const me = this
        let eventosFiltrados = me.platosMenu.filter((plato) => {
          return plato.fecha >= me.minDate
        })
        let eventosLocal = eventosFiltrados.map((evento) => {
          console.log('evento', evento)
          evento.plato.limited = evento.limited
          evento.plato.cantidad = evento.stock
          return {
            fechaFormateada: evento.fechaFormateada,
            plato: evento.plato
          }
        })
        let menusLocal = []
        let menusLocalAgrupados = _.groupBy(eventosLocal, 'fechaFormateada')
        _.forEach(menusLocalAgrupados, (item, idx) => {
          menusLocal.push({
            fecha: idx,
            platos: item
          })
        })
        // console.log('eventosLocales', menusLocal)
        me.$emit('activar-modal')
        console.log(me.stock)
        $.ajax({
          type: 'POST',
          url: '/api/restaurante/guardarmenu',
          data: {
            menus: menusLocal,
            stock: me.stock
          },
          dataType: 'json'
        }).done(() => {
          me.puedeSalir = true
          me.$emit('mostrar-notificacion', 'El menu se ha guardado correctamente', 'success')
        })
        .fail((err, err2) => {
          console.log(err, err2)
        })
        .always(() => {
          me.$emit('cerrar-modal')
        })
      },
      estaCompletoDia (fechaFormateada) {
        const me = this
        let platosDia = me.platosMenu.filter((plato) => {
          return plato.fechaFormateada === fechaFormateada
        })
        if (!platosDia) return
        let categoriasDia = platosDia.map((plato) => {
          return plato.categoria._id
        })
        let estaCompleto = me.categoriasObligatorias.every((categoria) => {
          return categoriasDia.includes(categoria)
        })
        return estaCompleto
      },
      goToNextPage () {
        const me = this
        if (me.paginador.currentPage < me.totalPages) {
          me.paginador.currentPage += 1
        }
      },
      goToPrevPage () {
        const me = this
        if (me.paginador.currentPage > 1) {
          me.paginador.currentPage -= 1
        }
      },
      platosMenuAEventos (arrPlatosMenu) {
        let arrResultado = arrPlatosMenu.map((plato) => {
          return {
            title: plato.plato.nombre,
            order: plato.plato.categoria.nombre.toUpperCase() + ' ' + plato.plato.nombre,
            idPlato: plato.plato._id,
            plato: plato.plato,
            start: moment(plato.fecha).utc(),
            fechaFormateada: plato.fechaFormateada,
            allDay: true
          }
        })
        return arrResultado
      }
    },
    beforeRouteLeave (from, to, next) {
      const me = this
      if (me.puedeSalir) {
        next()
      } else {
        swal({
          title: 'Hay cambios sin guardar',
          text: '¿Desea salir sin guadar los cambios?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Si, salir sin guardar',
          cancelButtonText: 'No, quiero quedarme y guardar'
        }).then(() => {
          next()
        }, (dismiss) => {
          next(false)
        })
      }
    },
    destroyed () {
      $('body').removeClass('admin show_sidebar')
    }
  }
</script>
<style scoped>
  .fc-event > .js-delete-event {
    background-color: transparent;
    border: 0;
    color: #444;
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
    padding-right: 0px;
    height: 20px;
    width: 20px;
  }
  .fc-event > .js-delete-event:hover {
    background-color: transparent;
    color: #CCC;
  }
  .js-buscar {
    height: 32px;
  }
  .etiqueta-categoria {
    color: #CACACA;
    background-color: #000;
  }


</style>



// WEBPACK FOOTER //
// AsignarMenu.vue?46d2f1c8